export const LOCATION_CHANGE = 'LOCATION_CHANGE'